import { decamelizeKeys } from 'humps'
import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { IGetEquipmentResponse } from 'apps/fleet-planner/types/equipment'
import { ISuccessAction } from 'apps/fleet-planner/utils/types/equipment'

export const FETCH_EQUIPMENT_ACTION_TYPES = generateApiActionTypes('FETCH_EQUIPMENT')

interface IEquipmentFilters {
  truckNumber?: string
  trailerNumber?: string
}
export interface IFetchEquipmentParams {
  motorCarrierId?: number
  filters?: IEquipmentFilters
}

export const fetchEquipment = (motorCarrierId?: number, filters?: IEquipmentFilters) => {
  const params: IFetchEquipmentParams = {}
  if (filters) {
    params.filters = filters
  }
  if (motorCarrierId) {
    params.motorCarrierId = motorCarrierId
  }

  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: FP_ENDPOINTS.equipment,
        method: 'GET',
        params: decamelizeKeys(params),
      },
      actionTypes: Object.keys(FETCH_EQUIPMENT_ACTION_TYPES),
    },
  }
}

export const fetchEquipmentSuccess = ({
  trailers = [],
  trucks = [],
}: IGetEquipmentResponse): ISuccessAction => ({
  type: FETCH_EQUIPMENT_ACTION_TYPES.FETCH_EQUIPMENT_SUCCESS,
  payload: {
    trucks,
    trailers,
  },
})
